module.exports = __webpack_public_path__ + "static/media/hs2.ff716761.jpg";